export default __webpack_public_path__ + "static/carlton-mg-logo-light-aacbcb818bcd96994c9cfd769759edad.png";